import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  d: "M8.33398 6.33301H11.6673",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M3.33268 4.66699C3.33268 4.20675 3.70578 3.83366 4.16602 3.83366H15.8327C16.2929 3.83366 16.666 4.20675 16.666 4.66699V8.00033C16.666 8.46056 17.0391 8.83366 17.4993 8.83366C17.9596 8.83366 18.3327 8.46056 18.3327 8.00033V4.66699C18.3327 3.28628 17.2134 2.16699 15.8327 2.16699H4.16602C2.7853 2.16699 1.66602 3.28628 1.66602 4.66699V16.3337C1.66602 17.7144 2.7853 18.8337 4.16602 18.8337H11.666C12.1263 18.8337 12.4993 18.4606 12.4993 18.0003C12.4993 17.5401 12.1263 17.167 11.666 17.167H4.16602C3.70578 17.167 3.33268 16.7939 3.33268 16.3337V4.66699Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("path", {
  d: "M15.8333 10.5C16.2936 10.5 16.6667 10.8731 16.6667 11.3333V13.8333C16.6667 14.2936 16.2936 14.6667 15.8333 14.6667C15.3731 14.6667 15 14.2936 15 13.8333V11.3333C15 10.8731 15.3731 10.5 15.8333 10.5Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("path", {
  d: "M15.8333 17.1667C16.2936 17.1667 16.6667 16.7936 16.6667 16.3333C16.6667 15.8731 16.2936 15.5 15.8333 15.5C15.3731 15.5 15 15.8731 15 16.3333C15 16.7936 15.3731 17.1667 15.8333 17.1667Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5
  ]))
}